export default __webpack_public_path__ + "static/media/user.29ab96de.svg";